<template>
  <div class="cart-product-card">
    <div class="upper-row d-flex align-center">
      <ProductImage class="image" border :src="image" />

      <div>
        <div class="genus">{{ orderItem.flower.flower_specie.flower_genus.name }}</div>
        <div class="specie">{{ orderItem.flower.flower_specie.name }}</div>
        <div class="purchase-deadline">購入期限: <span style="color: #555; font-weight: bold; font-size: 14px;">{{
        purchaseDeadline }}</span></div>
      </div>
    </div>
    <div class="lower-row d-flex flex-wrap">
      <div class="delete mr-auto" @click="$emit('delete')">削除する</div>
      <div :class="{'mb-4': mobile}">
        <div style="color: #444; margin-top: 5px; font-size: 16px">
          {{ $t("delivery_date") }}: <span style="color: #555; font-weight: bold; font-size: 20px;">{{ deliveryDate
          }}</span>
        </div>
      </div>

      <div class="purchase d-flex align-baseline justify-end">
        <div class="price-formula">
          <div class="unit-price">¥{{ $n(orderItem.flower_harvest.sales_price) }}</div>
          <div class="operator align-self-center">×</div>
          <div class="lot-wrapper">
            <div class="unit-price">{{ minLot }}</div>
            <div class="unit">本</div>
          </div>
          <div class="operator align-self-center">×</div>
          <div class="lot-wrapper">
            <div class="unit-price">{{ $n(orderItem.count / minLot) }}</div>
            <div class="unit">口</div>
          </div>
          <div class="operator align-self-center">=</div>
        </div>
        <div class="total-price"><span class="total-price-unit">¥</span>{{ $n(price) }}<span class="total-price-delivery-fee">（内送料¥{{ $n(delivery_fee) }}）</span></div>
      </div>
      <div v-if="isExpired" class="expired_message">
        <p>※購入期限を過ぎています。カートから削除してください。</p>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/plugins/i18n";
import times from "@/helpers/times";
import ProductImage from "@/components/shop/products/ProductImage.vue";

export default {
  components: {
    ProductImage
  },

  props: {
    orderItem: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      flowerHarvestId: this.orderItem.flower_harvest.id,
      flowerCount: this.orderItem.count,
      setCount: this.orderItem.count / this.orderItem.flower_harvest.min_count,
      deliveryDate: this.$d(this.orderItem.delivery_date, "date"),
      purchaseDeadline: this.$d(this.orderItem.flower_harvest.purchase_deadline, "datetime"),
      minLot: this.orderItem.flower_harvest.min_count,
      availableCount: this.orderItem.flower_harvest.available_count,
      isExpired: this.orderItem.flower_harvest.is_expired
    };
  },

  watch: {
    deliveryDate() {
      this.orderItem.flower_harvests.forEach(x => {
        const d = formatDate(x.harvest_date, "yyyy/m/d");

        if (d === this.deliveryDate) {
          this.minLot = x.min_count;
          this.availableCount = x.available_count;
          this.flowerHarvestId = x.id;
          this.flowerCount = null;
        }
      });
    }
  },

  created() {
    console.log("[]...", this.orderItem.flower_harvest.id);
    console.log("[]...", this.orderItem);
  },

  methods: {
    async editCountHandler() {
      class OrderItemPutError extends Error {
        constructor(status, message) {
          super(message);
          this.status = status;
          this.name = "OrderItemPutError";
        }
      }

      const data = {
        id: this.orderItem.id,
        count: this.setCount * this.minLot
      };
      try {
        const res_status = await this.$store.dispatch("orders/changeCount", data);
        if (res_status === 521) throw new OrderItemPutError(521, "Failed to change count");
        if (res_status !== 200) throw new Error("Failed to change count");

        if (this.flowerHarvestId !== this.orderItem.flower_harvest.id) {
          data.flowerHarvestId = this.flowerHarvestId;
        }
      } catch (e) {
        if (e.status === 521) {
          this.$store.dispatch("orders/notifyUnbuyableAreaError");
        } else {
          this.$store.dispatch("orders/notifyChangeCountError");
        }
        console.log(e);
      } finally {
        this.editCount = false;
      }
    },

    times
  },

  computed: {
    deliveryDates() {
      const dates = [];
      this.orderItem.flower_harvests.forEach(x => {
        dates.push(formatDate(x.harvest_date, "yyyy/m/d"));
      });

      if (!dates.includes(this.deliveryDate)) {
        dates.push(this.deliveryDate);
      }

      dates.sort();

      return dates;
    },

    price() {
      return this.flowerCount ? this.orderItem.count * this.orderItem.flower_harvest.sales_price : 0;
    },

    delivery_fee() {
      return this.flowerCount ? this.orderItem.count * this.orderItem.flower_harvest.delivery_fee : 0;
    },

    mobile() {
      return this.$vuetify.breakpoint.xs;
    },

    image() {
      if (this.orderItem.flower) {
        return this.orderItem.flower.images[0];
      }

      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
.cart-product-card {
  background-color: #fff;
  border: #ccc 1px solid;
  border-radius: 5px;
  padding: 8px 16px 8px 8px;
}

.image {
  width: 60px;
  height: 60px;
  border-radius: 5px;
  object-fit: cover;
}

.genus {
  margin-left: 8px;
  color: #007e57;
  font-size: 12px;
}

.specie {
  margin-left: 4px;
  color: #555;
  font-size: 18px;
}

.purchase-deadline {
  margin-left: 4px;
  color: #555;
  font-size: 12px;
}

.color {
  width: 140px;
  height: 40px;
  border: #ccc 1px solid;
  border-radius: 3px;
  padding: 0 8px;

  @media screen and (max-width: 960px) {
    width: auto;
    border: none;
  }
}

.lower-row {
  margin-top: 8px;
  border-top: #ccc 1px dashed;
  padding: 8px 0 0 8px;
}

.date {
  margin-top: 8px;
  font-size: 16px;
  color: #555;
}

.delete {
  margin-top: 8px;
  font-size: 16px;
  color: #d6225a;
  text-decoration: underline;
  cursor: pointer;
}

.purchase {
  width: 100%;
  color: #777;
  align-items: center !important;

  .price-formula {
    display: inline-flex;
  }

  .unit-price {
    font-weight: bold;
    font-size: 14px;
    line-height: 14px;
    color: #555;
    align-self: center;
    overflow-wrap: anywhere;
  }

  .lot-wrapper {
    display: flex;
    align-self: center;

    .unit {
      font-weight: bold;
      font-size: 10px;
      line-height: 12px;
      letter-spacing: 0.1em;
      align-self: end;
    }
  }

  .operator {
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.1em;
    margin: 0 4px;
  }

  .number {
    font-size: 24px;
    font-weight: bold;
    color: #555;
  }

  .total-price {
    margin-left: 8px;
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    color: #ff8c71;
    overflow-wrap: anywhere;

    &-unit {
      font-size: 18px;
      line-height: 22px;
    }

    &-delivery-fee {
      font-size: 14px;
      line-height: 17px;
    }
  }
}

.expired_message {
  margin: 10px 0;
  font-size: 12px;
  color: #d6225a;
  font-weight: bold;

  p {
    margin: 0;
  }
}
</style>
